"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(e){const{clientWidth:t}=e,{paddingLeft:d,paddingRight:o}=getComputedStyle(e);return t-parseFloat(d)-parseFloat(o)};



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/modals/~/@vds-core/scrollbars/cjs/utils/getInnerWidth.js
// module id = 1070
// module chunks = 0